import { render, staticRenderFns } from "./DrivingLicenseImage.vue?vue&type=template&id=aca841b8&scoped=true"
import script from "./DrivingLicenseImage.vue?vue&type=script&lang=js"
export * from "./DrivingLicenseImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca841b8",
  null
  
)

export default component.exports